import { sample } from 'effector';
import {
  $districtData,
  $districtModal,
  $okedsData,
  $okedsModal,
  $okedsModalsFilters,
  $regionData,
  $regionModal,
  $regionsOkedsData,
  $regionsOkedsModal,
  $subOkedsData,
  $subOkedsModal,
} from './stores.js';
import {
  changeDistrictModalEv,
  changeOkedsModalEv,
  changeOkedsModalsFiltersEv,
  changeRegionModalEv,
  changeRegionsOkedsModalEv,
  changeSubOkedsModalEv,
  DistrictModalGate,
  OkedsModalGate,
  RegionModalGate,
  RegionsOkedsGate,
  resetDistrictModalEv,
  resetOkedsModalEv,
  resetRegionModalEv,
  resetSubOkedsModalEv,
  SubOkedsModalGate,
} from './events.js';
import {
  getInvestProjectsActivityFx,
  getInvestProjectsDistrictFx,
  getInvestProjectsFx,
  getInvestProjectsRegionFx,
  getInvestProjectsSubActivityFx,
} from './effects.js';
import {
  $activitiesMap,
  $districtsMap,
  $regionsMap,
} from '../globalModel/index.js';
import {
  prepareDistrictData,
  prepareFilters,
  prepareOkedsData,
  prepareRegionData,
  prepareRegionsOkedsData,
  prepareSubOkedsData,
} from './utils.js';
import { $phasesMap } from '../dictionariesModel/index.js';
import { $activeFilters } from '../activeFiltersModel/index.js';

$regionsOkedsModal.on(changeRegionsOkedsModalEv, (state, payload) => {
  if (typeof payload === 'boolean') return payload;
  return !state;
});

$regionModal
  .on(changeRegionModalEv, (state, payload) => payload)
  .reset(resetRegionModalEv);

$districtModal
  .on(changeDistrictModalEv, (state, payload) => payload)
  .reset(resetDistrictModalEv);

$okedsModal
  .on(changeOkedsModalEv, (state, payload) => payload)
  .reset(resetOkedsModalEv);

$subOkedsModal
  .on(changeSubOkedsModalEv, (state, payload) => payload)
  .reset(resetSubOkedsModalEv);

$okedsModalsFilters.on(changeOkedsModalsFiltersEv, (state, payload) => ({
  ...state,
  ...payload,
}));

sample({
  source: $okedsModalsFilters,
  clock: RegionsOkedsGate.open,
  fn: (source) => prepareFilters(source),
  target: getInvestProjectsFx,
});

sample({
  source: $regionsOkedsModal,
  clock: $okedsModalsFilters.updates,
  filter: (modal) => !!modal,
  fn: (src, clock) => prepareFilters(clock),
  target: getInvestProjectsFx,
});

sample({
  source: [$regionsMap, $activitiesMap],
  clock: getInvestProjectsFx.doneData,
  fn: prepareRegionsOkedsData,
  target: $regionsOkedsData,
});

sample({
  source: $okedsModalsFilters,
  clock: RegionModalGate.open,
  fn: (source) => prepareFilters(source),
  target: getInvestProjectsRegionFx,
});

sample({
  source: RegionModalGate.status,
  clock: $okedsModalsFilters.updates,
  filter: (gate) => !!gate,
  fn: (src, clock) => prepareFilters(clock),
  target: getInvestProjectsRegionFx,
});

sample({
  source: [$districtsMap, $activitiesMap],
  clock: getInvestProjectsRegionFx.doneData,
  fn: prepareRegionData,
  target: $regionData,
});

sample({
  source: $okedsModalsFilters,
  clock: DistrictModalGate.open,
  fn: (source) => prepareFilters(source),
  target: getInvestProjectsDistrictFx,
});

sample({
  source: [$activitiesMap, $phasesMap],
  clock: getInvestProjectsDistrictFx.doneData,
  fn: prepareDistrictData,
  target: $districtData,
});

sample({
  source: $okedsModalsFilters,
  clock: OkedsModalGate.open,
  fn: (source) => prepareFilters(source),
  target: getInvestProjectsActivityFx,
});

sample({
  source: OkedsModalGate.status,
  clock: $okedsModalsFilters.updates,
  filter: (gate) => !!gate,
  fn: (_, clock) => prepareFilters(clock),
  target: getInvestProjectsActivityFx,
});

sample({
  source: $regionsMap,
  clock: getInvestProjectsActivityFx.doneData,
  fn: prepareOkedsData,
  target: $okedsData,
});

sample({
  source: $okedsModalsFilters,
  clock: SubOkedsModalGate.open,
  fn: (source) => prepareFilters(source),
  target: getInvestProjectsSubActivityFx,
});

sample({
  source: [$activitiesMap, $phasesMap],
  clock: getInvestProjectsSubActivityFx.doneData,
  fn: prepareSubOkedsData,
  target: $subOkedsData,
});

sample({
  clock: $activeFilters.updates,
  fn: (payload) => ({
    region_id: payload.region_id ?? null,
    district_id: payload.district_id ?? null,
    activity_id: payload.activity_id ?? null,
    oked_ids: payload.main_activity_id ?? [],
    project_type_ids: payload.project_type_id ?? [],
  }),
  target: $okedsModalsFilters,
});
